var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", { staticClass: "image is-24x24" }, [
    _c("img", { staticClass: "is-rounded", attrs: { src: _vm.getLink } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }